export default "__VITE_ASSET__Dpq_MgQJ__"